import React, { Component, Fragment } from 'react';
import {BeatLoader} from 'react-spinners';
import ReactTable from "react-table";
import NotificationSystem from 'react-notification-system';
import Datetime from 'react-datetime'
import '../../../../node_modules/react-datetime/css/react-datetime.css'
import {_addNotification,_addNotificationError,showFile, numberParce} from '../../../server/util';
import {date_format, currency_symbol} from '../../../server/constants';
import {get,postWithHeadersResponse, put, putWithHeadersResponse} from "../../../server/actions";
import NumberBox from '../../Misc/NumericBox';
import './index.css';
import moment from 'moment';
import Modal from 'react-modal';
import { groupBy } from 'lodash';
let download = require('downloadjs');
const customStyles = {
    content:{
      top:'50%',
      left:'50%',
      right:'auto',
      bottom:'auto',
      minWidth:'400px',
      marginRight:'-50%',
      transform:'translate(-50%, -50%)'
    }
  };
const filterEnum={
    'All':'All',
    'Approved':'Approved',
    'NotApproved':'Closed',
    'NotClosed':'Open'

}
class DailyPOSCash extends Component {
    constructor(props){
        super(props);
        this.state={
            approveConformModalIsOpen:false,
            closeSessionModalIsOpen:false,
            locations:[],
            locationFilter:'-1',
            modalRec:{},
            sessionCloseObj:{
                deviceId: "",
                closingCashBal: 0.00,
                mismatchBal: 0.00,
                note: "",
                sessionCloseTime:undefined,
                actualCloseBal:0.00,
                showActualAmt:false
              },
            loading:false,
            sessionData:[],
            filterList:[],
            currentDate:moment(),
            approveNote:'',
            fiterState:filterEnum.All
        }
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
        this.getLocationList();
        this.getPOSSessionList();
    }
    closeModal=(action,callback)=>{
        if(action==='A'){
            this.setState({approveConformModalIsOpen:false, approveNote:'', modalRec:{}},()=>{
                if(callback){
                    callback();
                }
            });
        }else{
            this.setState({closeSessionModalIsOpen:false, approveNote:'', modalRec:{},sessionCloseObj:{
                deviceId: "",
                closingCashBal: 0.00,
                mismatchBal: 0.00,
                note: "",
                sessionCloseTime:undefined,
                actualCloseBal:0.00
              } },()=>{
                if(callback){
                    callback();
                }
            });
        }
    }
    openModal=(action,rec)=>{
        if(action==='A'){
            this.setState({approveConformModalIsOpen:true, modalRec:rec});
        }else{            
            this.setState({closeSessionModalIsOpen:true, modalRec:rec},()=>{
                this.getActualCloseBal(rec);
            });
        }
    }
    getPOSSessionList=(isFile=false, isPdf=true)=>{
        const {currentDate, fiterState}=this.state;
        this.setState({loading: true});
        const schoolId=sessionStorage.getItem('SchoolId');        
        let _url=`/reports/getUserSessions/${schoolId}?startDt=${moment.utc(moment(currentDate).startOf('d')).format('YYYY-MM-DDThh:mm:ss')}&endDt=${moment.utc(moment(currentDate).endOf('d')).format('YYYY-MM-DDThh:mm:ss')}&type=${fiterState}&access_token=`;
        if(isFile){
            _url=`/reports/getUserSessions/${schoolId}?startDt=${moment.utc(moment(currentDate).startOf('d')).format('YYYY-MM-DDThh:mm:ss')}&endDt=${moment.utc(moment(currentDate).endOf('d')).format('YYYY-MM-DDThh:mm:ss')}&type=${fiterState}&fileType=${isPdf?'pdf':'Excel'}&access_token=`;
        }
        get(_url).then((response) => {            
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }else{
                throw Error(response.statusText);
                }
            }
            return response
        }).then(resp=>{
            this.setState({loading: false});
            if (resp.statusCode === 417) {
                 _addNotificationError(resp.statusMessage,this);
                 throw Error(resp.statusMessage);
            }else{
                if(isFile){
                return resp.blob();
                }else{
                    return resp.json();
                }
            }
        }).then(data => {
            if(isFile){
                let filename = "Daily POS Cash Report";
                if(isPdf){
                    showFile(data, filename);
                }else{
                    download(data,
                        filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                }
            }else{      
            this.setState({sessionData:data.resp,loading: false, filterList:data.resp},()=>{
                this.filterList()
            });
        }            
        }).catch(
            (error) => {
                this.setState({sessionData:[],loading: false, filterList:[]},()=>{
                    //this.filterList()
                });
            }
        );
    }
    filterList=()=>{
        let _filterList=[]
        switch(this.state.fiterState){
            case filterEnum.Approved:
                _filterList= this.state.sessionData.filter(itm=>{
                    return (itm.approvedTime||'')!==''
                });
                break;
            case filterEnum.NotApproved:
                _filterList= this.state.sessionData.filter(itm=>{
                    return (itm.approvedTime||'')==='' && (itm.sessionCloseTime||'')!==''
                });
                break
            case filterEnum.NotClosed:
                _filterList= this.state.sessionData.filter(itm=>{
                    return (itm.sessionCloseTime||'')===''
                });
                break
            case filterEnum.All:
                _filterList=this.state.sessionData;
                break;
            default:
                _filterList= [];
                break;
        }
        let _locationFilter=[];
        if((this.state.locationFilter||'')!='-1'){
            _locationFilter=_filterList.filter(itm=>{
                return (itm.locationId||'')==this.state.locationFilter;
            });
        }else{
            _locationFilter =_filterList
        }
        this.setState({filterList:_locationFilter});
    }
    getActualCloseBal=(rec)=>{
        const {currentDate,sessionCloseObj}=this.state;
        this.setState({loading: true});
        const schoolId=sessionStorage.getItem('SchoolId');
        get(`/getUsrSessionAmt/${schoolId}?deviceId=&sessionId=${rec.id}&access_token=`).then((response) => {            
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => { 
            sessionCloseObj.actualCloseBal= numberParce(data.resp);
            sessionCloseObj.deviceId=rec.deviceId,
            sessionCloseObj.sessionCloseTime=moment(this.state.currentDate).utc().format('YYYY-MM-DDThh:mm:ss');
            this.setState({sessionCloseObj:sessionCloseObj,loading: false});            
        }).catch(
            (error) => {
                this.setState({loading: false});
            }
        );
    }
    getLocationList=()=>{
        this.setState({loading: true});
        const schoolId=sessionStorage.getItem('SchoolId');
        get(`/posLocations/search/findByMealSchoolSchoolIdAndIsActive?isActive=true&mealSchoolId=${schoolId}&access_token=`).then((response) => {            
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {            
            this.setState({locations:(((data||{})._embedded||{}).posLocations||[]),loading: false});            
        }).catch(
            (error) => {
                this.setState({loading: false, locations:[]});
            }
        );
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    selectDate = (e) => {
        this.refs.calendar.closeCalendar()
       this.setState({currentDate:moment(e)},()=>{
        this.getPOSSessionList();
       });        
    }
    approveSession=(id)=>{
        let headers = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        this.setState({loading: true});
        putWithHeadersResponse(`/approveSession/${id}?access_token=`,JSON.stringify({note:this.state.modalRec.note}), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            if(data.statusCode==200){
                _addNotification(data.statusMessage,this)
            }else{
                _addNotification(data.errorMessage,this)
            }
            this.setState({loading: false, approveNote:''});
            this.closeModal('A',()=>{
                this.getPOSSessionList();
            });

        }).catch(
            (error) => {
                _addNotificationError('Something went wrong! Try Again.', this);
                this.setState({loading: false, approveNote:''});
            }
        );
        
    }
    closeingSession=()=>{
        let headers = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        this.setState({loading: true});
        const schoolId=sessionStorage.getItem('SchoolId');
        const {sessionCloseObj, modalRec}=this.state;
        const reqObj={...sessionCloseObj};
        reqObj.closingCashBal=numberParce(reqObj.closingCashBal);
        reqObj.mismatchBal=numberParce(reqObj.closingCashBal)-numberParce(reqObj.actualCloseBal);
        reqObj.cashPayment=numberParce(reqObj.actualCloseBal);
        putWithHeadersResponse(`/closeSession/${schoolId}?sessionId=${modalRec.id}&access_token=`,JSON.stringify(reqObj),headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            if(data.statusCode==200){
                _addNotification(data.statusMessage,this)
            }else{
                _addNotification(data.errorMessage,this)
            }
            this.setState({loading: false});
            this.closeModal('C',()=>{
                this.getPOSSessionList();
            });

        }).catch(
            (error) => {
                _addNotificationError('Something went wrong! Try Again.', this);
                this.setState({loading: false});
            }
        );        
        this.closeModal('C',()=>{
            this.getPOSSessionList();
        });

    }
    getCols=()=>{
        const locationGroup=groupBy(this.state.locations,'locationId');
        let cols=[
            {
                Header:'Device', 
                width:200,
                accessor:'deviceId', 
                style: {textAlign: 'center', 'whiteSpace': 'unset'},
                Cell:({row})=>{
                    const loc=row._original.locationId===null?'':((locationGroup[row._original.locationId]||[])[0]||{}).location||'';
                    return (<div style={{textAlign:'center'}}>
                    {row._original.userId}<br/><span>Device: {row._original.deviceId}</span>
                    {loc.length>0? <Fragment><br /><span>Location: {loc}</span></Fragment>:null} </div>)
                }
            },
            {
                Header:'Session',
                width:200,
                columns: [
                    {
                        Header:'Start', 
                        width:100,
                        accessor:'sessionStartTime', 
                        style: {textAlign: 'center', 'whiteSpace': 'unset'},
                        Cell:({row}) => (
                            <span style={{textAlign:'center'}}>
                                {`${row._original.sessionStartTime? moment(row._original.sessionStartTime).format(`${date_format()} hh:mm:ss`):''}`} </span>)
                        
                    },
                    {
                        Header:'End',
                        width:100, 
                        accessor:'sessionCloseTime', 
                        style: {textAlign: 'center', 'whiteSpace': 'unset'},
                        Cell:({row}) => (
                            <span style={{textAlign:'center'}}>
                                {`${row._original.sessionCloseTime? moment(row._original.sessionCloseTime).format(`${date_format()} hh:mm:ss`):''}`} </span>)
                        
                    },
                ]
            },
            {
                Header:'',
                width:200,
                columns: [
                    {
                        Header:'Opening', 
                        width:100,
                        accessor:'startingCashBal', 
                        style: {textAlign: 'center', 'whiteSpace': 'unset'},
                        Cell:({row}) => (
                            <span style={{textAlign:'center'}}>
                                {`${currency_symbol()} ${numberParce(row._original.startingCashBal).toFixed(2)}`} </span>)
                        
                    },
                    {
                        Header:'Cash Payment', 
                        width:100,
                        style: {textAlign: 'center'},
                        Cell:({row}) => (
                            <span style={{textAlign:'center', 'whiteSpace': 'unset'}}>
                                {`${currency_symbol()} ${(numberParce(row._original.cashPayment)).toFixed(2)}`} </span>)
                        
                    },
                    {
                        Header:'Ending', 
                        width:100,
                        accessor:'closingCashBal', 
                        style: {textAlign: 'center', 'whiteSpace': 'unset'},
                        Cell:({row}) => (
                            <span style={{textAlign:'center'}}>
                                {`${currency_symbol()} ${numberParce(row._original.closingCashBal).toFixed(2)}`} </span>)
                        
                    },
                    {
                        Header:'Register Actuals', 
                        width:100,
                        style: {textAlign: 'center', 'whiteSpace': 'unset'},
                        Cell:({row}) => (
                            <span style={{textAlign:'center'}}>
                                {`${currency_symbol()} ${(numberParce(row._original.startingCashBal+row._original.cashPayment)).toFixed(2)}`} </span>)
                        
                    },

                ]
            },       
            {
                Header:'Session Summary', 
                width:150,
                accessor:'mismatchBal', 
                style: {textAlign: 'center'},
                Cell:({row}) => {
                    const value=numberParce(row._original.mismatchBal)||0;
                    return (
                    <span style={{textAlign:'center', 'whiteSpace': 'unset'}}>
                        {`${currency_symbol()} ${value.toFixed(2)} ${value===0?'[Match]':(value<0?'[Under]' :'[Over]' )}`} </span>)
                    }
                
            },
            {
                Header:'Note', 
                accessor:'note', 
                style: {textAlign: 'center'},
                Cell:({row}) => (
                    <span style={{textAlign:'center', 'whiteSpace': 'unset'}}>
                        {`${row._original.note||''}`} </span>)
                
            }            
        ];
        if(this.state.fiterState==filterEnum.All)
        {
            cols.push(
                {
                    Header:'Action',
                    id:'approvedBy',
                    style: {textAlign: 'center', 'whiteSpace': 'unset'},
                    Cell:({row}) => {
                        return (<Fragment>
                            {
                                (row._original.approvedTime||'')!==''?
                                <span>{`${row._original.approvedBy||''}`}</span>:
                                (row._original.approvedTime||'')==='' && (row._original.sessionCloseTime||'')!==''?
                                <button className="btn btn-success btn-xs" style={{margin:'0px'}} onClick={()=>{
                                    this.openModal('A',row._original);            
                                }}>Accept</button>:
                                (row._original.sessionCloseTime||'')===''?
                                <button className="btn btn-info btn-xs" style={{margin:'0px'}} onClick={()=>{
                                    this.openModal('C',row._original);                                
                                }}>Close Session</button>:
                                null
                            }                            
                        </Fragment>)
                    }                                                        
                },
            );
        }else{
        if(this.state.fiterState==filterEnum.Approved){
            cols.push(
                {
                    Header:'Approved By',
                    id:'approvedBy',
                    style: {textAlign: 'center'},
                    Cell:({row}) => {
                        return (<Fragment>
                            <span>{`${row._original.approvedBy||''}`}</span>
                        </Fragment>)
                    }                                                        
                },
            );
        }
        else if(this.state.fiterState==filterEnum.NotApproved) {
            cols.push(
                {
                    Header:'Action',
                    id:'action',
                        style: {textAlign: 'center'},
                    Cell:({row}) => {
                    
                    return <button className="btn btn-success btn-xs" style={{margin:'0px'}} onClick={()=>{
                        this.openModal('A',row._original);

                    }}>Accept</button>
                }
            })
        }
        else if(this.state.fiterState==filterEnum.NotClosed){
            cols.push(
                {
                    Header:'Action',
                    id:'action',
                        style: {textAlign: 'center'},
                    Cell:({row}) => {
                    return <button className="btn btn-info btn-xs" style={{margin:'0px'}} onClick={()=>{
                        this.openModal('C',row._original);
                    
                    }}>Close Session</button>                    
                }
            })

        }
    }
        return cols;
    }
    render() {
        return (
        <Fragment>
            <NotificationSystem ref="notificationSystem"/>
            <section className=" full-width clearfix">
                <div className='sweet-loading'
                    style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                                loading={this.state.loading}
                            />
                </div>

                <div className="container">
                    <div className="row">
                        <div className="sectionTitle">
                            <div className="col-md-4">
                                <h2><span>Daily POS Cash Approval</span></h2>
                            </div>
                            <div className="col-md-8 text-right" style={{marginTop:'18px'}}>
                                <button type="button" 
                                    className={this.state.fiterState==filterEnum.All?"btn btn-xs btn-primary active":"btn btn-xs btn-inactive-color"}
                                    style={{margin: 0, marginLeft: 5, fontSize: 14}} 
                                    id={filterEnum.All}
                                    onClick={() => {
                                        this.setState({fiterState:filterEnum.All},()=>{
                                            this.getPOSSessionList()
                                        })
                                    }}>All
                                 </button>
                                <button type="button" 
                                    className={this.state.fiterState==filterEnum.Approved?"btn btn-xs btn-primary active":"btn btn-xs btn-inactive-color"}
                                    style={{margin: 0, marginLeft: 5, fontSize: 14}} 
                                    id={filterEnum.Approved}
                                    onClick={() => {
                                        this.setState({fiterState:filterEnum.Approved},()=>{
                                            this.getPOSSessionList()
                                        })
                                    }}>Approved
                                 </button>
                                 <button type="button" 
                                    className={this.state.fiterState==filterEnum.NotApproved?"btn btn-xs btn-primary active":"btn btn-xs btn-inactive-color"}
                                    style={{margin: 0, marginLeft: 5, fontSize: 14}} 
                                    id={filterEnum.NotApproved}
                                    onClick={() => {
                                        this.setState({fiterState:filterEnum.NotApproved},()=>{
                                            this.getPOSSessionList()
                                        })
                                    }}>Not Approved
                                 </button>
                                 <button type="button" 
                                    className={this.state.fiterState==filterEnum.NotClosed?"btn btn-xs btn-primary active":"btn btn-xs btn-inactive-color"}
                                    style={{margin: 0, marginLeft: 5, fontSize: 14}} 
                                    id={filterEnum.NotClosed}
                                    onClick={() => {
                                        this.setState({fiterState:filterEnum.NotClosed},()=>{
                                            this.getPOSSessionList()
                                        })
                                    }}>Not Closed Sessions
                                 </button>
                            </div>                                    
                        </div>
                    </div>
                    <div className="clearfix"></div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-primary">
                                <div className="panel-body">
                                    <div className='row' style={{marginBottom:'15px'}}>
                                        <div className='col-md-4'>
                                            <form className="form-inline">
                                                <div className="form-group">                                                    
                                                    <div className="uploadFileInfo col-md-12 createmenu-month-group">
                                                        <label className="custom-label col-md-3 text-left" style={{margin: '10px 0px'}}>Date</label>
                                                        <div className="input-group col-md-7 col-sm-12 col-xs-12">
                                                            <Datetime ref='calendar' dateFormat={date_format()} timeFormat={false} value={this.state.currentDate}
                                                                    closeOnSelect={true}                                                                    
                                                                    onChange={this.selectDate.bind(this)} renderInput={this.renderInput}/>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </form>                              
                                        </div>
                                        <div className='col-md-4'>
                                                <label className="custom-label col-md-3 text-left" style={{margin: '10px 0px'}}>Location</label>
                                                <div class="col-md-7">
                                                    <select className='form-control' onChange={(e)=>{
                                                        this.setState({locationFilter:e.target.value},()=>{
                                                            this.filterList()
                                                        });
                                                    }}>
                                                        <option value='-1'>All</option>
                                                        {
                                                            this.state.locations.map((loc,i)=>{
                                                                return <option key={i} value={loc.locationId}>{loc.location}</option>
                                                            })
                                                        }
                                                        <option value="" >Other</option>
                                                    </select>
                                                </div>
                                        </div>
                                        <div className='col-md-4'>
                                            <div style={{ 
                                                display: 'inline-block', 
                                                backgroundColor: 'transparent',
                                                float: 'right', 
                                                borderRadius: '3px' }}>              
                                                <div className="btn-group">
                                                    <button className="btn-primary btn-sm dropdown-toggle" type="button" 
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{color:'#fff', fontSize:'13px'}}>
                                                        <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                                    </button>
                                                    <ul className="dropdown-menu">
                                                        <li>
                                                            <a title="Click to Download PDF" style={{cursor:'pointer'}}
                                                                onClick={()=>{this.getPOSSessionList(true,true);}}
                                                                target='_blank'>
                                                                    <i className="fa fa-file-pdf-o" /> Pdf</a>
                                                        </li>
                                                        <li>
                                                            <a title="Click to Download Excel" style={{cursor:'pointer'}}
                                                                onClick={()=>{this.getPOSSessionList(true,false);}}
                                                                target='_blank'>
                                                                    <i className="fa fa-file-excel-o" /> Excel</a>
                                                        </li>                                                        
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">                                        
                                        <div className="col-md-12">

                                            <ReactTable
                                                data={this.state.filterList}
                                                columns={this.getCols()}
                                                defaultPageSize={10}
                                                className="-striped -highlight"
                                                noDataText='No data found'
                                                minRows = {2} 
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal 
                    isOpen={this.state.approveConformModalIsOpen}
                    onRequestClose={this.closeModal}
                    style={customStyles}
                    ariaHideApp={false}
                    contentLabel="">
                        <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Approve Session</h4>
                    </div>
                    <div className="modal-body">
                        <div className='row'>
                            <div className='col-md-12'>
                                <fieldset>
                                    <legend style={{fontSize:'14px', fontStyle:'italic', marginBottom:'5px'}}>Device Details:</legend>
                                    <div >
                                        <div className="sessionDetails"><span className='labelText'>Device :</span><strong className='labelValue'>{`${this.state.modalRec.deviceId}`}</strong></div>
                                        <div className="sessionDetails"><span className='labelText'>Opening Cash Bal. :</span><strong className='labelValue'>{`${currency_symbol()} ${numberParce( this.state.modalRec.startingCashBal).toFixed(2)}`}</strong></div>
                                        <div className="sessionDetails"><span className='labelText'>Closing Cash Bal. :</span><strong className='labelValue'>{`${currency_symbol()} ${numberParce(this.state.modalRec.closingCashBal).toFixed(2)}`}</strong></div>
                                        <div className="sessionDetails misMatch"><span className='labelText'>Mismatch Cash Bal. :</span><strong className='labelValue'>{`${currency_symbol()} ${numberParce(this.state.modalRec.mismatchBal).toFixed(2)}`}</strong></div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="form-group">
                                <label htmlFor="approveNote">Note</label>
                                <textarea type="text" className="form-control" value={this.state.modalRec.note} name="approveNote" onChange={(e)=>{
                                    const _modalRec=this.state.modalRec;
                                    _modalRec.note=e.target.value;
                                    this.setState({modalRec:_modalRec});
                                    }} id="approveNote" placeholder="" >                                                
                                </textarea>
                            </div>

                        </div>
                        <div className='row'>
                            <div className='col-md-12' style={{paddingTop:'10px'}}>
                                <p><b>Are you sure you want to Approve?</b></p>
                            </div>
                        </div>
                        
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => {
                                this.closeModal('A');
                                const _modalRec=this.state.modalRec;
                                _modalRec.note="";
                                this.setState({modalRec:_modalRec});
                            }}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> No
                                    </button>
                        <button type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }} onClick={()=>this.approveSession(this.state.modalRec.id)}
                            id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Yes
                        </button>
                    </div>
                </Modal>
                <Modal 
                    isOpen={this.state.closeSessionModalIsOpen}
                    onRequestClose={this.closeModal}
                    style={customStyles}
                    ariaHideApp={false}
                    contentLabel="">
                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">Closing Balance</h4>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-md-12'>
                                    <form>
                                        <div className="form-group">
                                            <label htmlFor="txtClosingCashBal">{`Closing Balance (${currency_symbol()})`}</label>
                                            <NumberBox type="text" className="form-control" maxLength="6" 
                                                value={this.state.sessionCloseObj.closingCashBal} 
                                                id="txtClosingCashBal" name="closingCashBal" placeholder="0.00"  
                                                style={{textAlign:'right'}} 
                                                onChange={(e)=>{
                                                    const _sessionCloseObj={...this.state.sessionCloseObj};
                                                    _sessionCloseObj.closingCashBal=e.target.value;
                                                    this.setState({sessionCloseObj:_sessionCloseObj});
                                                }} noValidate onBlur={(e)=>{
                                                    const _sessionCloseObj={...this.state.sessionCloseObj};
                                                    const mismatchBal=numberParce(_sessionCloseObj.closingCashBal)-numberParce(_sessionCloseObj.actualCloseBal);
                                                    if (mismatchBal!==0.00){
                                                        _sessionCloseObj.showActualAmt=true;                                                        
                                                    }else{
                                                        _sessionCloseObj.showActualAmt=false;
                                                    }
                                                    this.setState({sessionCloseObj:_sessionCloseObj});
                                                }}/>{
                                                    this.state.sessionCloseObj.showActualAmt?
                                                    <div className='text-left' style={{    color: '#cd5c5c', fontSize:'13px'}}>
                                                    <span>{`Actual closing balance amount is ${currency_symbol()} ${numberParce(this.state.sessionCloseObj.actualCloseBal)}`}</span>

                                                </div>:null
                                                }
                                                
                                        </div>
                                        
                                        <div className="form-group">
                                            <label htmlFor="txtNote">Note</label>
                                            <textarea type="text" className="form-control" name="node" onChange={(e)=>{
                                                const _sessionCloseObj={...this.state.sessionCloseObj};
                                                _sessionCloseObj.note=e.target.value;
                                                this.setState({sessionCloseObj:_sessionCloseObj});
                                            }} id="txtNote" placeholder="" >                                                
                                            </textarea>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => this.closeModal('C')}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> No
                                    </button>
                        <button type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }} onClick={()=>this.closeingSession()}
                            id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Yes
                        </button>
                    </div>                       
                </Modal>
            </section>
        </Fragment>);
    }
}

export default DailyPOSCash;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/DailyPOSCash/index.jsx